import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
// Actions
import { SetOrderLocked, SetOrderUnlocked } from './actions/quality-order-detail.actions';
// Models
import { OrderCI_ORDERDETAIL_STATE_PATH, OrderDetailModel, OrderLockedBy } from './model/order-detail.model';

@State<OrderDetailModel>({
	name: OrderCI_ORDERDETAIL_STATE_PATH,
	defaults: new OrderDetailModel()
})
@Injectable()
export class QualityOrderDetailState {

	/**
	 * Get Feature Quality Order Detail State Model.
	 * @param state: OrderDetailModel
	 */
	@Selector()
	static getOrderDetail(state: OrderDetailModel): OrderDetailModel {
		return state;
	}

	/**
	 * Get Order Lock Status State Model.
	 * @param state: OrderDetailModel
	 */
	@Selector()
	static getOrderLockedBy(state: OrderDetailModel): OrderLockedBy {
		return state.lockedBy;
	}

	/**
	 * Set Order to locked state
	 * @param ctx
	 * @param locked
	 * @param lockedBy
	 * @constructor
	 */
	@Action(SetOrderLocked)
	SetOrderLocked(ctx: StateContext<OrderDetailModel>, { locked, lockedBy }: SetOrderLocked): void {
		ctx.patchState({
			locked,
			lockedBy
		});
	}

	/**
	 * Set Order to unlocked state
	 * @param ctx
	 * @constructor
	 */
	@Action(SetOrderUnlocked)
	SetOrderUnlocked(ctx: StateContext<OrderDetailModel>): void {
		const locked = null;
		const lockedBy = null;
		ctx.patchState({
			locked,
			lockedBy
		});
	}
}
